export enum SWIPE_DIRECTION {
    NULL,
    RIGHT,
    LEFT,
}

interface Point {
    x: number;
    y: number
}

/**
 * 根据起点和终点判断滑动方向
 */
export function getSwipeDirection(start: Point, end: Point): SWIPE_DIRECTION {
    const { x: startX = 0, y: startY = 0 } = start;
    const { x: endX = 0, y: endY = 0 } = end;
    const xDist = startX - endX;
    const yDist = startY - endY;
    const r = Math.atan2(yDist, xDist);
    let swipeAngle = Math.round((r * 180) / Math.PI);

    if (swipeAngle < 0) {
        swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0) {
        return SWIPE_DIRECTION.RIGHT;
    }
    if (swipeAngle <= 360 && swipeAngle >= 315) {
        return SWIPE_DIRECTION.RIGHT;
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
        return SWIPE_DIRECTION.LEFT;
    }

    return SWIPE_DIRECTION.NULL;
}


/**
 * 协助计算滑动的一些数据
 */
export class SwipeHelper {
    private startPoint: Point | null = null;
    private startTime: number;

    public constructor(private minDistance: number, private maxDuration: number) {}

    public handleTouchStart(event: React.TouchEvent) {
        if (event.touches.length > 1 || event.touches.length === 0) {
            return;
        }
        const { pageX, pageY } = event.touches[0];
        this.startPoint = { x: pageX, y: pageY };
        this.startTime = Date.now();
    }

    public handleTouchMove(event: React.TouchEvent) {
        if (event.touches.length > 1 || event.touches.length === 0) {
            return;
        }
        if (!this.startPoint) {
            const { pageX, pageY } = event.touches[0];
            this.startPoint = { x: pageX, y: pageY };
        }
        if (!this.startTime) {
            this.startTime = Date.now();
        }
    }

    public reset() {
        this.startTime = 0;
        this.startPoint = null;
    }

    public getSwipeDirection(event: React.TouchEvent) {
        if (!this.startPoint) {
            return null;
        }
        if (event.changedTouches.length > 1 || event.changedTouches.length === 0) {
            return null;
        }
        const { pageX, pageY } = event.changedTouches[0];
        const endPoint = { x: pageX, y: pageY };
        const swipeDirection = getSwipeDirection(this.startPoint, endPoint);
        if (swipeDirection === SWIPE_DIRECTION.NULL) {
            return null;
        }
        const distance = Math.abs(endPoint.x - this.startPoint.x);
        const duration = Date.now() - this.startTime;
        if (distance > this.minDistance && duration < this.maxDuration) {
            return swipeDirection;
        }
    }
}
